
    
// Whenever an item with the "animate-on-view" class comes into view add a class
document.querySelectorAll('.animate-on-view').forEach(function(element) {
  console.log('Observing: ', element)

  var animation = new IntersectionObserver(function(entries) {
    
    var element = entries[0]

    if(entries[0].isIntersecting === true){
      element.target.classList.add('visible')
    } else {
      element.target.classList.remove('visible')
    }
  
  }, { threshold: [0] })
  
  animation.observe(element)
  
})


